<template>
  <span v-resize="checkMobile" data-testid="admin-users-page">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-card>
      <v-toolbar :color="$vuetify.theme.dark ? '' : 'white'">
        <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('custom.search')" single-line clearable
          hide-details data-testid="users-search"></v-text-field>
        <v-btn v-if="!isIos" icon :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
          }/${$root.$i18n.locale}/categories/9`" target="_blank">
          <v-icon>mdi-help-circle</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table :headers="headers" :items="employees" :search="search" :loading="isLoading"
        :loading-text="$t('custom.loading_table')"
        :class="!isMobile ? 'elevation-1 mt-2' : 'elevation-1 mt-2 is-mobile'" mobile-breakpoint="100" :footer-props="tableFooterProps([20, 50, 100, -1])">
        <template v-slot:item="props">
          <tr>
            <td class="text-center">
              <v-chip class="ma-2" :color="checkLogin(props.item.id) || props.item.login
                ? 'green'
                : 'secondery'
                " text-color="white">
                {{ props.item.id }}
              </v-chip>
            </td>
            <td class="text-center">
              {{ formatCreatedAt(props.item.last_login) }}
            </td>
            <td class="text-center">
              <router-link :to="`/admin/users/${props.item.id}`">
                {{ props.item.name }}
              </router-link>
            </td>
            <!-- email — персональные данные: внешним зрителям (guest/partner) не показывается;
                 isGuest/isPartner — глобальный roleMixin, роль ЗРИТЕЛЯ, не строки -->
            <td class="text-center" :style="isGuest || isPartner ? 'display: none;' : ''">
              <router-link :to="`/admin/users/${props.item.id}`">
                {{ props.item.email }}
              </router-link>
            </td>
            <td class="text-center">
              {{ roleLabel(props.item.role) }}
            </td>
            <td v-if="company && company.multicurrency_cashboxes" class="text-center">
              <span v-for="currency_account in getUserCurrencyAccounts(props.item.id)" :key="currency_account.id">
                <span v-if="checkActivityCashbox(currency_account.currency_id)">{{
                  (parseFloat(currency_account.cash) || 0).toFixed(2) }} {{ findCurrencySymbol(currency_account.currency_id)
                  }}&nbsp;</span>
              </span>
            </td>
            <td v-else class="text-center">
              {{ getUserAccount(props.item.id) }}{{ currency }}
            </td>
            <td nowrap class="text-center">
              <v-icon class="mr-2" color="success" @click="voteUp(props.item)" :title="props.item.vote_up">
                mdi-thumb-up-outline
              </v-icon>
              <v-icon class="mr-2" color="grey" @click="voteDown(props.item)" :title="props.item.vote_down">
                mdi-thumb-down-outline
              </v-icon>
              <v-avatar color="primary" size="30px">
                {{ props.item.vote_up - props.item.vote_down }}
              </v-avatar>
            </td>
            <td nowrap class="text-center">
              <v-btn small @click="setUser(props.item.id), (kassa_dialog = true)" class="text-center mr-2" color="info">
                {{ $t("custom.counts") }}
              </v-btn>
              <v-btn v-if="props.item.traccar_id == null && main_company && main_company.beacons_on == true" small icon
                @click="addUserToTraccar(props.item.id)" class="text-center" color="pink">
                <v-icon>mdi-map-marker-plus-outline</v-icon>
              </v-btn>
              <v-btn v-if="props.item.traccar_id != null" small icon @click="removeUserFromTraccar(props.item.id)"
                class="text-center" color="error">
                <v-icon>mdi-map-marker-off-outline</v-icon>
              </v-btn>
            </td>
            <td v-if="showCrmAccessColumn" class="text-center">
              <crm-access-toggle :user="props.item" />
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-flex md12 :class="isMobile ? 'text-center' : 'd-flex justify-center text-center'">
          <v-flex v-if="checkAdminManager()">
            <v-btn small color="success" :to="{ name: 'CreateEmployee' }" class="mt-2 mr-2 mb-2">{{ $t("employers.add")
            }}</v-btn>
          </v-flex>
          <v-flex v-if="!showNotActive">
            <v-btn small @click="showNotActive = true" class="mt-2 mb-2">{{ $t("employers.show_dismiss") }}</v-btn>
          </v-flex>
          <v-flex v-if="showNotActive">
            <v-btn small @click="showNotActive = false" class="mt-2 mb-2">{{ $t("employers.remove_dismiss") }}</v-btn>
          </v-flex>
          <v-flex v-if="!showAllUsers">
            <v-btn small @click="showAllUsers = true" class="mt-2 mb-2 ml-2">{{ $t("employers.show_all_users")
            }}</v-btn>
          </v-flex>
          <v-flex v-if="showAllUsers">
            <v-btn small @click="showAllUsers = false" class="mt-2 mb-2 ml-2">{{ $t("employers.not_show_all_users")
            }}</v-btn>
          </v-flex>
        </v-flex>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="kassa_dialog" :retain-focus="false" persistent fullscreen hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-card-title v-if="company && company.multicurrency_cashboxes" :class="isMobile ? 'pt-10' : 'headline'">
          {{ $t("custom.counts") }} - {{ user.name }}
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'" @click="kassa_dialog = false">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-title v-else :class="isMobile ? 'pt-10' : 'headline'">
          {{ $t("custom.counts") }} - {{ user.name }}
          <v-icon class="ml-2 green--text" @click="updateUserKassa()">
            mdi-content-save-all-outline
          </v-icon>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'" @click="
            (kassa_dialog = false),
            (money_track = false),
            (user = { account: { cash: 0 } }),
            (user_cash = 0),
            (get_cash = 0),
            (give_cash = 0)
            ">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-row v-if="company && company.multicurrency_cashboxes" class="mb-0">
            <v-col md12 cols="12" class="mb-2">
              <v-flex md12 v-if="user && active_user_currency_accounts && active_user_currency_accounts.length > 0">
                <v-select v-model="selected_currency_account" :item-text="item => `${item.name}: ${item.cash}`"
                  item-value="id" return-object :items="active_user_currency_accounts"
                  :label="$t('companies.select_cashbox')" hide-no-data hide-details></v-select>
              </v-flex>
            </v-col>
            <v-col md12 v-if="selected_currency_account && selected_currency_account.id">
              <v-row>
                <v-col md1 class="mr-2">
                  <v-text-field readonly v-model="selected_currency_account.cash" :label="$t('counts.in_count')"
                    hide-details></v-text-field>
                </v-col>
                <v-col md2 class="mr-2">
                  <v-text-field :disabled="selected_currency_account.give_cash > 0"
                    v-model.number="selected_currency_account.get_cash" hide-details
                    :label="$t('counts.get_cash')"></v-text-field>
                </v-col>
                <v-col md2 class="mr-2">
                  <v-text-field :disabled="selected_currency_account.get_cash > 0"
                    v-model.number="selected_currency_account.give_cash" hide-details
                    :label="$t('counts.give_cash')"></v-text-field>
                </v-col>
                <v-col md4 class="mr-2" v-if="checkAdmin()">
                  <v-radio-group v-model="selected_currency_account.money_track" row hide-details>
                    <v-radio :label="$t('counts.company_counts')" :value="true"></v-radio>
                    <v-radio :disabled="currentUserId == user.id" :label="$t('counts.employee_count')"
                      :value="false"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col v-if="company && company.multicurrency_cashboxes" md2 class="my-auto">
                  <v-btn color="success" small @click="updateUserKassaWithCurrency(selected_currency_account)">{{
                    $t("custom.save")
                    }}</v-btn>
                </v-col>
                <v-col v-else md2 class="my-auto">
                  <v-btn color="success" small @click="updateUserKassa()">{{ $t("custom.save")
                  }}</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-flex v-else>
            <v-container>
              <v-layout row wrap>
                <v-flex md1 class="mr-2">
                  <v-text-field readonly v-model.number="user.account.cash"
                    :label="$t('counts.in_count')"></v-text-field>
                </v-flex>
                <v-flex md2 class="mr-2">
                  <v-text-field :disabled="give_cash > 0" v-model.number="get_cash"
                    :label="$t('counts.get_cash')"></v-text-field>
                </v-flex>
                <v-flex md2 class="mr-2">
                  <v-text-field :disabled="get_cash > 0" v-model.number="give_cash"
                    :label="$t('counts.give_cash')"></v-text-field>
                </v-flex>
                <v-flex md4 class="mr-2" v-if="checkAdmin()">
                  <v-radio-group v-model="money_track" row>
                    <v-radio :label="$t('counts.company_counts')" :value="true"></v-radio>
                    <v-radio :disabled="currentUserId == user.id" :label="$t('counts.employee_count')"
                      :value="false"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex md2 class="mr-2 mb-2 align-center">
                  <v-btn color="success" @click="updateUserKassa()">{{
                    $t("custom.save")
                    }}</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
          <v-flex md12>
            <v-card>
              <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'">
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('custom.search')" single-line
                  clearable hide-details></v-text-field>
              </v-toolbar>
              <v-data-table :headers="headers_cashier" :items="counts" :search="search" :loading="table_counts_loading"
                :loading-text="$t('custom.loading_table')" :class="!isMobile ? '' : 'is-mobile'" :items-per-page="20"
                mobile-breakpoint="100" :sort-by="['created_at']" :sort-desc="[true]" :footer-props="tableFooterProps([20, 50, 100, -1])">
                <template slot="item" slot-scope="props">
                  <tr :class="props.item.operation && props.item.sum < 0
                    ? 'red--text'
                    : ''
                    ">
                    <td class="text-center">{{ props.item.id }}</td>
                    <td class="text-center">
                      {{ returnDate(props.item.created_at) }}
                    </td>
                    <td class="text-center">
                      <v-icon v-if="!isForeignBranchCount(props.item)" @click="editCount(props.item)">
                        mdi-pencil-outline
                      </v-icon>
                      <v-icon v-else color="grey lighten-1"
                        v-tooltip="tooltipConfig($t('errors.foreign_branch_count'))">
                        mdi-lock-outline
                      </v-icon>
                    </td>
                    <td class="text-center">
                      {{ translateCategory(props.item.group) }}
                    </td>
                    <td class="text-center">
                      {{ props.item.description }}
                    </td>
                    
                    <td v-if="company && company.multicurrency_cashboxes" class="text-center">
                      <span :title="$t('counts.last_balance') + ': ' + props.item.last_balance" style="cursor: pointer;"
                        @click="showLastBalanceDialog = true, last_balance = props.item.last_balance">
                        {{ props.item.sum }}{{ findCurrencySymbol(props.item.currency_id) }}
                      </span>
                      <span
                        v-if="props.item.rate && (props.item.rate != 1 && props.item.rate != 0) && props.item.rate != null">
                        ({{ props.item.rated_sum }})
                      </span>
                    </td>
                    <td v-else class="text-center">
                      <span :title="$t('counts.last_balance') + ': ' + props.item.last_balance" style="cursor: pointer;"
                        @click="showLastBalanceDialog = true, last_balance = props.item.last_balance">
                        {{ props.item.sum }}{{ currency }}
                      </span>
                    </td>
                    <td class="text-center" v-if="props.item.operation">
                      <v-icon class="text-center" style="color: green">
                        mdi-plus-circle-outline
                      </v-icon>
                    </td>
                    <td class="text-center" v-if="!props.item.operation">
                      <v-icon class="text-center" style="color: tomato">
                        mdi-minus-circle-outline
                      </v-icon>
                    </td>
                    <td class="text-center">
                      <v-icon v-if="paymentType(props.item)" class="text-center" :color="paymentType(props.item).color"
                        v-tooltip="tooltipConfig(paymentType(props.item).label)">
                        {{ paymentType(props.item).icon }}
                      </v-icon>
                      <span v-else>-</span>
                    </td>
                    <td class="text-center" nowrap v-if="
                      props.item.booking_id &&
                      props.item.car_id &&
                      props.item.car_code
                    ">
                      <p>
                        {{ $t("bookings.booking") }}:
                        <router-link :to="{
                          path: `/bookings/${props.item.booking_id}`,
                        }">
                          {{ props.item.booking_id }}
                        </router-link>
                      </p>
                      <p>
                        {{ $t("custom.car") }}:
                        <router-link :to="{ path: `/cars/${props.item.car_id}` }">
                          {{ props.item.car_code }}
                        </router-link>
                      </p>
                    </td>
                    <td class="text-center" v-else-if="props.item.car_id && props.item.car_code">
                      {{ $t("custom.car") }}:
                      <router-link :to="{ path: `/cars/${props.item.car_id}` }">{{ props.item.car_code
                      }}</router-link>
                    </td>
                    <td class="text-center" v-else-if="props.item.source">
                      {{ props.item.source }}
                    </td>
                    <td class="text-center" v-else-if="props.item.debt_id">
                      {{ $t("custom.deb") }} №{{ props.item.debt_id }}
                    </td>
                    <td class="text-center" v-else-if="props.item.agent_id">
                      {{ $t("agents.agent") }} {{ $t("custom.number") }}
                      <router-link :to="{ path: `/agent_card/${props.item.agent_id}` }">
                        {{ props.item.agent_id }}
                      </router-link>
                    </td>
                    <td class="text-center" v-else>-</td>
                    <td class="text-center">
                      <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon class="ml-2" v-tooltip="tooltipConfig(checkStateView(props.item.check).tooltip)"
                            v-bind="attrs" v-on="on" :color="checkStateView(props.item.check).color">
                            {{ checkStateView(props.item.check).icon }}
                          </v-icon>
                        </template>
                        <v-list>
                          <v-list-item v-for="(state, index) in countStates" :key="index" @click="
                            updateCountCheck(props.item.id, state.state)
                            ">
                            <v-list-item-title>
                              {{ state.text }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </template>
                <template slot="no-data">
                  {{ $t("custom.no_data_in_table") }}
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                  {{ $t("tables.no_search_result", { msg: search }) }}
                </v-alert>
              </v-data-table>
            </v-card>
          </v-flex>
          <v-flex md12>
            <h2>{{ $t("counts.daily") }}</h2>
            <v-card>
              <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'">
                <v-spacer></v-spacer>
                <v-text-field v-model="search_cashbox" append-icon="mdi-magnify" :label="$t('custom.search')"
                  single-line clearable hide-details></v-text-field>
              </v-toolbar>
              <v-data-table :headers="headers_cashboxes" :items="user_cashbox" :search="search_cashbox"
                :loading="table_counts_loading" :loading-text="$t('custom.loading_table')"
                :class="!isMobile ? '' : 'is-mobile'" :items-per-page="7" :sort-by="['created_at']"
                mobile-breakpoint="100" :sort-desc="[true]" :footer-props="tableFooterProps([7, 20, 50, 100, -1])">
                <template slot="item" slot-scope="props">
                  <tr>
                    <td class="text-center">{{ props.item.id }}</td>
                    <td class="text-center">
                      {{ formatCreatedAt(props.item.created_at) }}
                    </td>
                    <td class="text-center" v-if="company && company.multicurrency_cashboxes">
                      <span v-for="(balance, company_cashbox_id) in props.item.currency_balances"
                        :key="company_cashbox_id">
                        {{ findCashboxName(company_cashbox_id) }}: {{ balance }}
                      </span>
                    </td>
                    <td class="text-center" v-else>
                      {{ props.item.account }}{{ currency }}
                    </td>
                  </tr>
                </template>
                <template slot="no-data">
                  {{ $t("custom.no_data_in_table") }}
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
                  {{ $t("tables.no_search_result", { msg: search }) }}
                </v-alert>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" :retain-focus="false" persistent max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("custom.editing") }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-form>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12 sm1 md1>
                    <v-text-field v-model.number="editedCount.sum" :label="$t('custom.amount')" readonly></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-combobox v-model="selected_count.group" :items="counts_groups" item-text="text"
                      item-value="value" :label="$t('custom.select_group')"></v-combobox>
                  </v-flex>
                  <v-flex xs12 sm4 md4>
                    <v-autocomplete v-model="selected_car" item-text="code" item-value="id" text hide-no-data
                      hide-details :label="$t('custom.select_car')" :items="cars">
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm3 md3>
                    <v-radio-group v-model="editedCount.operation" row>
                      <v-radio :label="$t('custom.income')" :value="true"></v-radio>
                      <v-radio :label="$t('custom.expences')" :value="false"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex class="text-center my-auto">
                    <v-icon v-if="editedCount.cashless" color="warning">
                      mdi-contactless-payment-circle-outline
                    </v-icon>
                    <v-icon v-else-if="editedCount.cash_card" color="success">
                      mdi-credit-card-check-outline
                    </v-icon>
                    <v-icon v-else color="success">
                      mdi-cash
                    </v-icon>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-textarea v-model="editedCount.description" :label="$t('counts.about')"
                      :placeholder="$t('counts.about_placeholder')"></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="editDialog = false">{{
            $t("custom.close")
            }}</v-btn>
          <v-btn color="blue darken-1" text @click="saveCount()">{{
            $t("custom.save")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showLastBalanceDialog" :retain-focus="false" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-icon :class="$vuetify.theme.dark ? 'ml-2 white--text' : 'ml-2 black--text'"
            @click="showLastBalanceDialog = false, last_balance = 0">
            mdi-close
          </v-icon>
        </v-card-title>
        <v-card-text>{{ $t("counts.last_balance") }}: {{ last_balance }}</v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { setMomentLocale } from "@/utils/localeInfra";
import moment from "moment";
import "moment/locale/ru";
import "moment/locale/en-gb";
import { Capacitor } from "@capacitor/core";
import PullToRefresh from "pulltorefreshjs";
import CrmAccessToggle from "@/components/admin/users/CrmAccessToggle.vue";
export default {
  name: "UsersList",
  components: {
    CrmAccessToggle,
  },
  data() {
    return {
      users: [],
      accounts: [],
      counts: [],
      editedCount: [],
      cars: [],
      selected_car: [],
      counts_groups: [
        { text: this.$t("groups_counts.repair"), value: "Ремонт" },
        { text: this.$t("groups_counts.service"), value: "Обслуживание" },
        { text: this.$t("groups_counts.parts"), value: "Запчасти" },
        { text: this.$t("groups_counts.insurance_main"), value: "Страховка" },
        {
          text: this.$t("groups_counts.common_expences"),
          value: "Накладные расходы",
        },
        {
          text: this.$t("groups_counts.transport_expences"),
          value: "Транспортные расходы",
        },
        { text: this.$t("groups_counts.tax"), value: "Налоги" },
        { text: this.$t("groups_counts.fines_main"), value: "Штрафы" },
        {
          text: this.$t("groups_counts.rent_property"),
          value: "Аренда имущества",
        },
        {
          text: this.$t("groups_counts.clean_main"),
          value: "Мойка автомобилей",
        },
        { text: this.$t("groups_counts.fuel_main"), value: "Топливо" },
        { text: this.$t("groups_counts.ads"), value: "Реклама" },
        {
          text: this.$t("groups_counts.sell_property"),
          value: "Продажа имущества",
        },
        {
          text: this.$t("groups_counts.buy_property"),
          value: "Покупка имущества",
        },
        {
          text: this.$t("groups_counts.partners_payments"),
          value: "Выплаты партнёрам",
        },
        {
          text: this.$t("groups_counts.other_expences"),
          value: "Прочие расходы",
        },
        {
          text: this.$t("groups_counts.other_incomes"),
          value: "Прочие доходы",
        },
      ],
      selected_count: [],
      selected_currency_account: {
        cash: 0,
        get_cash: 0,
        give_cash: 0,
        money_track: false,
      },
      cashboxes: [],
      user_cashbox: [],
      money_track: false,
      user: {
        account: {
          cash: 0,
        },
      },
      user_cash: 0,
      get_cash: 0,
      give_cash: 0,
      headers: [
        { text: this.$t("custom.id"), align: "center", value: "id" },
        {
          text: this.$t("other.last_active"),
          align: "center",
          value: "last_login",
        },
        { text: this.$t("check_lists.worker"), value: "name", align: "center" },
        { text: this.$t("custom.email"), value: "email", align: "center" },
        { text: this.$t("other.role"), value: "role", align: "center" },
        { text: this.$t("other.account"), sortable: true, align: "center" },
        { text: this.$t("employers.efficiency"), sortable: false, align: "center" },
        { text: this.$t("check_lists.control"), align: "center" },
      ],
      headers_cashboxes: [
        { text: this.$t("custom.id"), align: "center", value: "id" },
        { text: this.$t("custom.date"), value: "created_at", align: "center" },
        { text: this.$t("custom.counts"), value: "account", align: "center" },
      ],
      headers_cashier: [
        { text: this.$t("custom.number"), align: "center", value: "id" },
        {
          text: this.$t("custom.created_at"),
          value: "created_at",
          align: "center",
        },
        { text: this.$t("custom.editor"), sortable: false, align: "center" },
        {
          text: this.$t("custom.group"),
          sortable: true,
          value: "group",
          align: "center",
        },
        {
          text: this.$t("custom.description"),
          sortable: false,
          value: "description",
          align: "center",
        },
        {
          text: this.$t("custom.amount"),
          sortable: false,
          value: "sum",
          align: "center",
        },
        {
          text: this.$t("custom.operation"),
          value: "operation",
          align: "center",
        },
        { text: this.$t("custom.type"), value: "cashless", align: "center" },
        { text: this.$t("custom.source"), sortable: false, align: "center" },
        { text: this.$t("custom.state"), value: "check", align: "center" },
      ],
      countStates: [
        { state: true, text: this.$t("counts.checked") },
        { state: false, text: this.$t("counts.not_approved") },
        { state: null, text: this.$t("counts.not_finded") },
      ],
      search: "",
      search_cashbox: "",
      kassa_dialog: false,
      editDialog: false,
      showNotActive: false,
      showAllUsers: false,
      table_counts_loading: false,
      last_balance: 0,
      showLastBalanceDialog: false,
      isLoading: true,
      isMobile: false,
    };
  },
  mounted() {
    let self = this;
    const ptr = PullToRefresh.init({
      mainElement: "body",
      distIgnore: 100,
      instructionsPullToRefresh: this.$t("custom.pull_to_refresh"),
      instructionsReleaseToRefresh: this.$t("custom.release_to_refresh"),
      instructionsRefreshing: this.$t("custom.refreshing"),
    });
  },
  created() {
    let self = this;
    // CRM access column (REQ-19) — only for CRM admins when CRM is enabled
    if (this.showCrmAccessColumn) {
      this.headers.push({
        text: this.$t("crm.list.headers.crm_access"),
        value: "crm_access",
        sortable: false,
        align: "center",
      });
    }
    // moment Locale
    setMomentLocale(this.$i18n.locale);
    if (
      this.$store.getters.isLoggedIn &&
      (this.isManagerPlus || this.isGuest)
    ) {
      this.axios
        .get("api/v1/users", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.users = response.data.filter((user) => !this.isSupport(user.id));
          response.data.forEach((user) => {
            this.accounts.push(user.account);
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.workers_load"));
        });

      this.axios
        .get("/api/v1/active_cars", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.cars = [];
          response.data.data.forEach((element) => {
            this.cars.push(element.attributes);
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.cars_load"));
          console.log(error);
        });
      this.axios
        .get("/api/v1/cashboxes", {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.cashboxes = response.data;
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.cashboxes_load"));
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    } else {
      this.$router.replace("/");
    }
  },
  watch: {
    get_cash() {
      this.user.account.cash = this.user_cash;
      this.user.account.cash -= this.get_cash;
      this.user.account.operation = false;
    },
    give_cash() {
      this.user.account.cash = this.user_cash;
      this.user.account.cash += this.give_cash;
      this.user.account.operation = true;
    },
  },
  computed: {
    active_company_cashboxes() {
      if (!this.company || !this.company.company_cashboxes) {
        return [];
      }
      return this.company.company_cashboxes
        .filter((cashbox) => cashbox.id && cashbox.is_active)
        .sort((a, b) => (b.is_default === true) - (a.is_default === true));
    },
    currency_accounts() {
      if (this.$store.getters.getCurrentUser && this.$store.getters.getCurrentUser.currency_accounts) {
        let accounts = [];
        this.$store.getters.getCurrentUser.currency_accounts.forEach((account) => {
          if (this.active_company_cashboxes.find((cashbox) => (cashbox.id == account.company_cashbox_id || cashbox.currency_id == account.currency_id))) {
            accounts.push(account);
          }
        });
        return accounts;
      } else {
        return [];
      }
    },
    active_user_currency_accounts() {
      if (this.user && this.user.currency_accounts) {
        let accounts = [];
        this.user.currency_accounts.forEach((account) => {
          if (this.checkActivityCashbox(account.currency_id)) {
            account.name = this.findCashboxName(account.company_cashbox_id, account.currency_id);
            accounts.push(account);
          }
        });
        return accounts;
      } else {
        return [];
      }
    },
    currency() {
      return (this.company && this.company.currency) || "";
    },
    currentUserId() {
      return this.$store.getters.currentUserId;
    },
    showCrmAccessColumn() {
      return (
        this.$store.getters["crm/isCrmAdmin"] &&
        this.$store.getters["crm/isCrmEnabled"]
      );
    },
    employees() {
      // Фильтр уволенных обязан жить здесь, а не в v-if строки слота:
      // иначе пагинация и счётчик считают скрытые строки (видно 5 из «15»)
      let users = this.showAllUsers
        ? this.users
        : this.users.filter(
          (user) => user.role != "partner" && user.role != "guest"
        );
      if (!this.showNotActive) {
        users = users.filter((user) => user.active);
      }
      return users;
    },
    currencies() {
      return (this.company && this.company.currencies) || [];
    },
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
    main_company() {
      return this.$store.getters.getMainCompany;
    },
    company() {
      const store_company = this.$store.getters.getCompany;
      return (store_company && store_company.company) || null;
    },
    current_user() {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    isSupport(id) {
      return [1, 4, 976, 13794].includes(id)
    },
    checkLogin(id) {
      let user = this.$store.getters.getLoginUsers.find(
        (user) => user.id == id
      );
      if (user && user.login == true) {
        return true;
      } else {
        return false;
      }
    },
    getUserAccount(id) {
      let account = this.accounts.find((account) => account.user_id == id);
      if (account && account.cash != null) {
        // Преобразуем в число и округляем до 2 знаков после запятой
        let cashValue = parseFloat(account.cash) || 0;
        account.cash = parseFloat(cashValue.toFixed(2));
        return account.cash;
      } else {
        return 0;
      }
    },
    getUserCurrencyAccounts(id) {
      let accounts = this.users.find((user) => user.id == id).currency_accounts;
      if (accounts) {
        return accounts;
      } else {
        return [];
      }
    },
    setUser(id) {
      let self = this;
      this.isLoading = true;
      this.user = this.users.find((user) => user.id === id);
      this.user_cashbox = this.cashboxes.filter(
        (cashbox) => cashbox.user_id == id
      );
      this.user_cash = this.user.account.cash;
      this.user.currency_accounts.forEach((account) => {
        account.get_cash = 0;
        account.give_cash = 0;
        if (this.$store.getters.currentUserId == id) {
          account.money_track = true;
        } else {
          account.money_track = false;
        }
      });
      // Немультивалютный диалог держит money_track скаляром, и он инициализирован
      // false. Радио «на счёт сотрудника» для своей же строки задизейблено, но
      // остаётся выбранным — то есть по умолчанию уходил перевод самому себе,
      // который портит остаток (сервер теперь отвечает на него 422).
      // Как в AgentsList#setUser: своя строка — значит касса компании.
      if (this.$store.getters.currentUserId == id) {
        this.money_track = true;
      }
      this.table_counts_loading = true;
      this.axios
        .get(`/api/v1/workers_counts/${this.user.id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.counts = [];
          response.data.data.forEach((count) => {
            self.counts.push(count.attributes);
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.cashboxes_worker_load"));
          console.log(error);
        })
        .finally(
          () => ((this.isLoading = false), (this.table_counts_loading = false))
        );
    },
    updateUserKassaWithCurrency(currency_account) {
      if (this.isStaff) {
        let self = this;
        if (currency_account.get_cash == 0 && currency_account.give_cash == 0) {
          this.$notify(this.$t("errors.cashbox_null"), this.$t("errors.cashbox_null_text"), "warning");
        } else {
          this.isLoading = true;
          // проверка если админ
          let money_track = false;
          if (this.checkAdmin()) {
            money_track = currency_account.money_track;
          }
          this.axios
            .post(
              `/api/v1/manual_update_account`,
              {
                user_id: this.user.id,
                money_track: money_track,
                sum: parseFloat((parseFloat(currency_account.get_cash) + parseFloat(currency_account.give_cash)).toFixed(2)),
                get_cash: currency_account.get_cash > 0 ? true : false,
                company_cashbox_id: currency_account.company_cashbox_id,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              if (!money_track) {
                if (currency_account.get_cash > 0) {
                  let updated_user = this.users.find((user) => user.id == this.user.id)
                  // Гвард (issue #128): счёта может не оказаться — .cash у
                  // undefined ронял TypeError и обрывал обновление списка.
                  const targetAccountGet = updated_user && updated_user.currency_accounts.find(
                    (account) => account.id == currency_account.id
                  );
                  if (targetAccountGet) targetAccountGet.cash -= currency_account.get_cash;
                  this.users.splice(
                    this.users.findIndex((user) => user.id == this.user.id),
                    1,
                    updated_user
                  );
                  // update current user
                  let finded_current_user = this.users.find((user) => user.id == this.$store.getters.getCurrentUser.id);
                  let finded_currency_account = finded_current_user.currency_accounts.find(
                    (account) => account.company_cashbox_id == currency_account.company_cashbox_id
                  )
                  if (!finded_currency_account) {
                    // Ищем по валюте
                    finded_currency_account = finded_current_user.currency_accounts.find(
                      (account) => account.currency_id == currency_account.currency_id
                    )
                  }
                  // Гвард (issue #128): у текущего пользователя может вовсе не
                  // быть счёта в этой валюте — TypeError на .cash обрывал поток.
                  // splice только при найденном индексе (findIndex -1 менял бы
                  // ПОСЛЕДНИЙ элемент массива).
                  if (finded_currency_account) {
                    // Сервер (accounts#manual_update, get_cash + !money_track) начисляет
                    // сумму на счёт админа: забрал у сотрудника — своя касса выросла.
                    // Здесь стоял минус, и экран уезжал на 2×сумму до перезагрузки.
                    finded_currency_account.cash = finded_currency_account.cash + currency_account.get_cash;
                    const currentAccountIdx = finded_current_user.currency_accounts.findIndex(
                      (account) => account.id == finded_currency_account.id
                    );
                    if (currentAccountIdx >= 0) {
                      finded_current_user.currency_accounts.splice(currentAccountIdx, 1, finded_currency_account);
                    }
                  }
                  this.users.splice(
                    this.users.findIndex((user) => user.id == finded_current_user.id),
                    1,
                    finded_current_user
                  );
                } else {
                  let updated_user = this.users.find((user) => user.id == this.user.id)
                  // Гвард (issue #128), зеркально ветке get_cash выше.
                  const targetAccountGive = updated_user && updated_user.currency_accounts.find(
                    (account) => account.company_cashbox_id == currency_account.company_cashbox_id
                  );
                  if (targetAccountGive) targetAccountGive.cash += currency_account.give_cash;
                  this.users.splice(
                    this.users.findIndex((user) => user.id == this.user.id),
                    1,
                    updated_user
                  );
                  // update current user
                  let finded_current_user = this.users.find((user) => user.id == this.$store.getters.getCurrentUser.id);
                  let finded_currency_account = finded_current_user.currency_accounts.find(
                    (account) => account.company_cashbox_id == currency_account.company_cashbox_id
                  )
                  if (!finded_currency_account) {
                    // Ищем по валюте
                    finded_currency_account = finded_current_user.currency_accounts.find(
                      (account) => account.currency_id == currency_account.currency_id
                    )
                  }
                  // Гвард (issue #128), зеркально ветке get_cash выше.
                  if (finded_currency_account) {
                    finded_currency_account.cash = finded_currency_account.cash - currency_account.give_cash;
                    const currentAccountIdxGive = finded_current_user.currency_accounts.findIndex(
                      (account) => account.id == finded_currency_account.id
                    );
                    if (currentAccountIdxGive >= 0) {
                      finded_current_user.currency_accounts.splice(currentAccountIdxGive, 1, finded_currency_account);
                    }
                  }
                  this.users.splice(
                    this.users.findIndex((user) => user.id == finded_current_user.id),
                    1,
                    finded_current_user
                  );
                }
              } else {
                let updated_user = this.users.find((user) => user.id == this.user.id)
                if (currency_account.get_cash > 0) {
                  updated_user.currency_accounts.find(
                    (account) => account.company_cashbox_id == currency_account.company_cashbox_id
                  ).cash -= currency_account.get_cash;
                } else {
                  updated_user.currency_accounts.find(
                    (account) => account.company_cashbox_id == currency_account.company_cashbox_id
                  ).cash += currency_account.give_cash;
                }
                this.users.splice(
                  this.users.findIndex((user) => user.id == this.user.id),
                  1,
                  updated_user
                );

              }
              self.kassa_dialog = false;
              // self.user = { account: { cash: 0 } };
              // self.user_cash = 0;
              currency_account.get_cash = 0;
              currency_account.give_cash = 0;
              this.user.currency_accounts.forEach((account) => {
                account.get_cash = 0;
                account.give_cash = 0;
              });
              self.$notify(self.$t("counts.cashbox_updated"), self.$t("counts.cashbox_updated_text"), "success");
            })
            .catch((error) => {
              this.setError(error, this.$t("errors.cashbox_update"));
            })
            .finally(() => (this.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    updateUserKassa() {
      if (this.isStaff) {
        let user = this.user;
        let self = this;
        if (this.get_cash == 0 && this.give_cash == 0) {
          this.$notify(this.$t("errors.cashbox_null"), this.$t("errors.cashbox_null_text"), "warning");
        } else {
          this.isLoading = true;
          // проверка если админ
          let money_track = false;
          if (this.checkAdmin()) {
            money_track = self.money_track;
          }
          this.axios
            .post(
              `/api/v1/manual_update_account`,
              {
                user_id: user.id,
                money_track: money_track,
                sum: parseFloat((parseFloat(self.get_cash) + parseFloat(self.give_cash)).toFixed(2)),
                get_cash: self.get_cash > 0 ? true : false,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              if (!self.money_track) {
                if (self.get_cash > 0) {
                  self.accounts.find(
                    (account) =>
                      account.user_id == self.$store.getters.currentUserId
                  ).cash += self.get_cash;
                } else {
                  self.accounts.find(
                    (account) =>
                      account.user_id == self.$store.getters.currentUserId
                  ).cash -= self.give_cash;
                }
              }
              self.kassa_dialog = false;
              self.user = { account: { cash: 0 } };
              self.user_cash = 0;
              self.get_cash = 0;
              self.give_cash = 0;
              self.$notify(self.$t("counts.cashbox_updated"), self.$t("counts.cashbox_updated_text"), "success");
            })
            .catch((error) => {
              self.setError(error, self.$t("errors.cashbox_update"));
            })
            .finally(() => (self.isLoading = false));
        }
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    // Строка журнала может принадлежать СОСЕДНЕМУ филиалу того же тенанта: личный счёт
    // привязан к человеку, наличные переезжают вместе с ним, поэтому журнал сотрудника
    // законно пересекает филиалы (api#565). А правка и смена статуса платежа на сервере
    // скоуплены филиалом — и правильно: денежные ветки двигают кассы своего филиала.
    // Значит действие по чужефилиальной строке вернёт 404, и предлагать его нельзя.
    isForeignBranchCount(count) {
      const own = this.company && this.company.id;
      return !!(own && count && count.company_id && count.company_id !== own);
    },
    editCount(count) {
      if (this.isForeignBranchCount(count)) {
        this.$notify(this.$t("errors.foreign_branch_count"), "", "warning");
        return;
      }
      this.isLoading = true;
      this.editDialog = true;
      this.axios
        .get(`/api/v1/counts/${count.id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.editedCount = response.data;
          this.selected_count = response.data;
          this.selected_count.group = this.translateCategory(
            this.selected_count.group
          );
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.load_counts"));
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
      if (count.car_id) {
        this.isLoading = true;
        this.axios
          .get(`/api/v1/cars/${count.car_id}`, {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          })
          .then((response) => {
            this.selected_car = response.data;
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.load_cars"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      }
    },
    saveCount() {
      if (this.isStaff) {
        this.isLoading = true;
        let count = this.editedCount;
        let self = this;
        this.axios
          .patch(
            `/api/v1/counts/${count.id}`,
            {
              counts: {
                sum: count.sum,
                operation: count.operation,
                description: count.description,
                // проблема в этом при обновлении
                group: this.selected_count.group.value,
                car_id: this.selected_car,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.editDialog = false;
            let foundIndex = this.counts.findIndex(
              (element) => element.id === count.id
            );
            // count.group = response.data.group;
            this.counts.splice(foundIndex, 1, response.data);
            // console.log(count)
            this.$notify(this.$t("counts.update_count_title"), this.$t("counts.update_count_text"), "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.update_count"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    updateCountCheck(id, state) {
      const target = this.counts.find((element) => element.id === id);
      if (this.isForeignBranchCount(target)) {
        this.$notify(this.$t("errors.foreign_branch_count"), "", "warning");
        return;
      }
      if (this.isManagerPlus) {
        this.isLoading = true;
        let self = this;
        let count = this.counts.find((element) => element.id === id);
        this.axios
          .patch(
            `/api/v1/counts/${count.id}`,
            {
              counts: {
                check: state,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            let foundIndex = this.counts.findIndex(
              (element) => element.id === id
            );
            count.check = state;
            this.counts.splice(foundIndex, 1, count);

            this.$notify(this.$t("counts.state_updated"), "", "success");
          })
          .catch((error) => {
            this.setError(error, this.$t("errors.count_state"));
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    checkActivityCashbox(currency_id) {
      if (this.active_company_cashboxes.find((cashbox) => cashbox.currency_id == currency_id)) {
        return true;
      } else {
        return false;
      }
    },
    addUserToTraccar(user_id) {
      this.isLoading = true;
      this.axios
        .post(
          `/api/v1/add_to_traccar`,
          {
            id: user_id,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then(() => {
          this.users.find((user) => user.id == user_id).traccar_id = 999999;
          this.$notify(this.$t("cars.added_to_traccar"), "", "success");
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
        })
        .finally(() => (this.isLoading = false));
    },
    removeUserFromTraccar(user_id) {
      this.isLoading = true;
      this.axios
        .post(
          `/api/v1/remove_from_traccar`,
          {
            id: user_id,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then(() => {
          this.users.find((user) => user.id == user_id).traccar_id = null;
          this.$notify(this.$t("cars.removed_from_traccar"), "", "success");
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
        })
        .finally(() => (this.isLoading = false));
    },
    voteUp(user) {
      if (this.current_user && this.current_user.id != user.id) {
        var self = this;
        this.axios
          .post(
            `/api/v1/employee_vote_up`,
            {
              id: user.id,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.users.find((employee) => employee.id == user.id).vote_up = parseInt(response.data);
          })
          .catch((error) => {
            this.setError(error,);
          })
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    voteDown(user) {
      if (this.current_user && this.current_user.id != user.id) {
        var self = this;
        this.axios
          .post(
            `/api/v1/employee_vote_down`,
            {
              id: user.id,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then((response) => {
            this.users.find((employee) => employee.id == user.id).vote_down = parseInt(response.data);
          })
          .catch((error) => {
            this.setError(error,);
          })
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    },
    translateCategory(category) {
      let group_text = "";
      switch (category) {
        case "Оплата аренды":
          group_text = this.$t("groups_counts.rent");
          break;
        case "Доплата за доставку":
          group_text = this.$t("groups_counts.delivery");
          break;
        case "Доплата за приём":
          group_text = this.$t("groups_counts.checkout");
          break;
        case "Доплата за топливо":
          group_text = this.$t("groups_counts.fuel");
          break;
        case "Доплата за мойку":
          group_text = this.$t("groups_counts.clean");
          break;
        case "Доплата за оборудование":
          group_text = this.$t("groups_counts.equipment");
          break;
        case "Доплата за дополнительное время":
          group_text = this.$t("groups_counts.add_time");
          break;
        case "Доплата за повреждения":
          group_text = this.$t("groups_counts.damages");
          break;
        case "Доплата за штрафы":
          group_text = this.$t("groups_counts.fines");
          break;
        case "Доплата за другое":
          group_text = this.$t("groups_counts.other");
          break;
        case "Доплата за превышение пробега":
          group_text = this.$t("groups_counts.mileage");
          break;
        case "Доплата за страховку":
          group_text = this.$t("groups_counts.insurance");
          break;
        case "Доплата за доп водителей":
          group_text = this.$t("groups_counts.add_drivers");
          break;
        case "Ремонт":
          group_text = this.$t("groups_counts.repair");
          break;
        case "Обслуживание":
          group_text = this.$t("groups_counts.service");
          break;
        case "Запчасти":
          group_text = this.$t("groups_counts.parts");
          break;
        case "Страховка":
          group_text = this.$t("groups_counts.insurance_main");
          break;
        case "Накладные расходы":
          group_text = this.$t("groups_counts.common_expences");
          break;
        case "Транспортные расходы":
          group_text = this.$t("groups_counts.transport_expences");
          break;
        case "Налоги":
          group_text = this.$t("groups_counts.tax");
          break;
        case "Штрафы":
          group_text = this.$t("groups_counts.fines_main");
          break;
        case "Аренда имущества":
          group_text = this.$t("groups_counts.rent_property");
          break;
        case "Мойка автомобилей":
          group_text = this.$t("groups_counts.clean_main");
          break;
        case "Топливо":
          group_text = this.$t("groups_counts.fuel_main");
          break;
        case "Реклама":
          group_text = this.$t("groups_counts.ads");
          break;
        case "Зарплата":
          group_text = this.$t("groups_counts.salary");
          break;
        case "Залог":
          group_text = this.$t("groups_counts.deposit");
          break;
        case "Внутренние переводы":
          group_text = this.$t("groups_counts.internal");
          break;
        case "Продажа имущества":
          group_text = this.$t("groups_counts.sell_property");
          break;
        case "Покупка имущества":
          group_text = this.$t("groups_counts.buy_property");
          break;
        case "Прочие расходы":
          group_text = this.$t("groups_counts.other_expences");
          break;
        case "Прочие доходы":
          group_text = this.$t("groups_counts.other_incomes");
          break;
        case "Выплаты партнёрам":
          group_text = this.$t("groups_counts.partners_payments");
          break;
        case "Сервисные сборы":
          group_text = this.$t("groups_counts.service_fees");
          break;
        case "Пополнение баланса клиента":
          group_text = this.$t("groups_counts.top_up_client_balance");
          break;
        case "Выплаты агентам":
          group_text = this.$t("groups_counts.agent_payments");
          break;
      }
      return group_text;
    },
    formatCreatedAt(date) {
      if (date) {
        return moment.parseZone(date).format("DD MMM H:mm");
      } else {
        return "-";
      }
    },
    returnDate(item) {
      if (item) {
        return moment(item, "YYYY-MM-DD H:mm").format("DD MMM H:mm");
      } else {
        return "-";
      }
    },
    findCashboxName(company_cashbox_id, currency_id) {
      if (company_cashbox_id == null) {
        return "-";
      }
      const cashbox = this.active_company_cashboxes.find(
        (company_cashbox) => company_cashbox.id == company_cashbox_id
      );
      if (cashbox) {
        return cashbox.name;
      }
      const currency = this.currencies.find(
        (company_currency) => company_currency.id == currency_id
      );
      return currency ? currency.symbol : undefined;
    },
    checkAdminManager() {
      return (
        this.$store.getters.isSuperAdmin ||
        this.$store.getters.isAdmin ||
        this.$store.getters.isManager
      );
    },
    checkAdmin() {
      return this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin;
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    roleLabel(role) {
      const role_keys = {
        user: "employee",
        manager: "manager",
        admin: "admin",
        superadmin: "superadmin",
        partner: "partner",
        guest: "guest",
      };
      // Неизвестная роль показывается как есть — ячейка обязана отрисоваться,
      // иначе строка съезжает относительно заголовков
      return role_keys[role] ? this.$t(`employers.${role_keys[role]}`) : role;
    },
    paymentType(count) {
      if (count.cash) {
        return { icon: "mdi-cash", color: "success", label: this.$t("money.cash") };
      }
      if (count.cashless) {
        return { icon: "mdi-contactless-payment-circle-outline", color: "warning", label: this.$t("money.terminal") };
      }
      if (count.entity) {
        return { icon: "mdi-bank", color: "secondary", label: this.$t("money.from_entity") };
      }
      if (count.cash_card) {
        return { icon: "mdi-credit-card-check-outline", color: "success", label: this.$t("money.card_to_card") };
      }
      if (count.client_balance) {
        return { icon: "mdi-account-arrow-right", color: "error", label: this.$t("money.client_balance") };
      }
      return null;
    },
    checkStateView(check) {
      if (check === true) {
        return { icon: "mdi-checkbox-outline", color: "success", tooltip: this.$t("tooltips.trust_invoice") };
      }
      if (check === false) {
        return { icon: "mdi-bookmark-remove-outline", color: "error", tooltip: this.$t("tooltips.bad_invoice") };
      }
      return { icon: "mdi-map-marker-question-outline", color: "secondary", tooltip: this.$t("tooltips.some_invoice") };
    },
    tooltipConfig(content) {
      return {
        content: content,
        placement: "bottom-center",
        classes: ["info"],
        targetClasses: ["it-has-a-tooltip"],
        delay: {
          show: 500,
          hide: 500,
        },
      };
    },
  },
};
</script>
<style>
.is-mobile .v-data-footer__select {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.is-mobile .v-data-footer__icons-before {
  margin: 0 auto !important;
}

.is-mobile .v-data-footer__icons-after {
  margin: 0 auto !important;
}
</style>
